import ManageMedia from '~/api/manage_media';
import { Message, MessageBox } from 'element-ui';

export default {
    async getActiveMarkupForm({state, commit, dispatch, rootState}) {
        try {
            const data = await ManageMedia.getActiveMarkupForm(rootState.media.media.media_id);
            commit('media/markup/createMarkupForm', data, {root: true});
            return data;
        } catch (error) {
            console.error(error);
        }
    },

    saveMarkup({state, commit, dispatch, rootState}, value) {
        ManageMedia.saveMarkup(value)
        .then(response => {
            commit('media/updateMedia', {
                active_cost_split_id: response.id
            }, {root: true});

            Message.success('Cost split saved successfully');
        })
        .catch(error => {
            Message.error('There was an error saving cost split');
        });
    }
};